/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pick_The_Typography_And_Framing_For_Your_Printed_PInputs */

const en_pick_the_typography_and_framing_for_your_printed_p = /** @type {(inputs: Pick_The_Typography_And_Framing_For_Your_Printed_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick the typography and framing for your printed pages.`)
};

const es_pick_the_typography_and_framing_for_your_printed_p = /** @type {(inputs: Pick_The_Typography_And_Framing_For_Your_Printed_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige la tipografía y el enmarcado para tus páginas impresas.`)
};

const fr_pick_the_typography_and_framing_for_your_printed_p = /** @type {(inputs: Pick_The_Typography_And_Framing_For_Your_Printed_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez la typographie et le cadrage pour vos pages imprimées.`)
};

const de_pick_the_typography_and_framing_for_your_printed_p = /** @type {(inputs: Pick_The_Typography_And_Framing_For_Your_Printed_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie die Typografie und Rahmung für Ihre gedruckten Seiten.`)
};

const ja_pick_the_typography_and_framing_for_your_printed_p = /** @type {(inputs: Pick_The_Typography_And_Framing_For_Your_Printed_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`印刷ページのタイポグラフィとフレーミングを選択してください。`)
};

const zh_pick_the_typography_and_framing_for_your_printed_p = /** @type {(inputs: Pick_The_Typography_And_Framing_For_Your_Printed_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为您的印刷页面选择排版和边框。`)
};

const ar_pick_the_typography_and_framing_for_your_printed_p = /** @type {(inputs: Pick_The_Typography_And_Framing_For_Your_Printed_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اختر الطباعة والإطارات لصفحاتك المطبوعة.`)
};

const id_pick_the_typography_and_framing_for_your_printed_p = /** @type {(inputs: Pick_The_Typography_And_Framing_For_Your_Printed_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih tipografi dan pembingkaian untuk halaman cetak Anda.`)
};

const it_pick_the_typography_and_framing_for_your_printed_p = /** @type {(inputs: Pick_The_Typography_And_Framing_For_Your_Printed_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli la tipografia e l'inquadratura per le tue pagine stampate.`)
};

const ru_pick_the_typography_and_framing_for_your_printed_p = /** @type {(inputs: Pick_The_Typography_And_Framing_For_Your_Printed_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите типографику и рамки для ваших печатных страниц.`)
};

const pt_pick_the_typography_and_framing_for_your_printed_p = /** @type {(inputs: Pick_The_Typography_And_Framing_For_Your_Printed_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha a tipografia e o enquadramento para as suas páginas impressas.`)
};

const ko_pick_the_typography_and_framing_for_your_printed_p = /** @type {(inputs: Pick_The_Typography_And_Framing_For_Your_Printed_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인쇄될 페이지의 타이포그래피와 프레임을 선택하세요.`)
};

/**
* | output |
* | --- |
* | "Pick the typography and framing for your printed pages." |
*
* @param {Pick_The_Typography_And_Framing_For_Your_Printed_PInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pick_the_typography_and_framing_for_your_printed_p = /** @type {((inputs?: Pick_The_Typography_And_Framing_For_Your_Printed_PInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pick_The_Typography_And_Framing_For_Your_Printed_PInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pick_the_typography_and_framing_for_your_printed_p(inputs)
	if (locale === "es") return es_pick_the_typography_and_framing_for_your_printed_p(inputs)
	if (locale === "fr") return fr_pick_the_typography_and_framing_for_your_printed_p(inputs)
	if (locale === "de") return de_pick_the_typography_and_framing_for_your_printed_p(inputs)
	if (locale === "ja") return ja_pick_the_typography_and_framing_for_your_printed_p(inputs)
	if (locale === "zh") return zh_pick_the_typography_and_framing_for_your_printed_p(inputs)
	if (locale === "ar") return ar_pick_the_typography_and_framing_for_your_printed_p(inputs)
	if (locale === "id") return id_pick_the_typography_and_framing_for_your_printed_p(inputs)
	if (locale === "it") return it_pick_the_typography_and_framing_for_your_printed_p(inputs)
	if (locale === "ru") return ru_pick_the_typography_and_framing_for_your_printed_p(inputs)
	if (locale === "pt") return pt_pick_the_typography_and_framing_for_your_printed_p(inputs)
	return ko_pick_the_typography_and_framing_for_your_printed_p(inputs)
});